






















































































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

import BrandAndModel from '@/views/reports/forms/flow/views/conditions/brand-and-model.vue';
import BrowserAndVersion from '@/views/reports/forms/flow/views/conditions/browser-and-version.vue';
import OsAndVersion from '@/views/reports/forms/flow/views/conditions/os-and-version.vue';
import Dictionary from '@/views/reports/forms/flow/views/conditions/dictionary.vue';
import ConnectionType from '@/views/reports/forms/flow/views/conditions/connection-type.vue';
import Custom from '@/views/reports/forms/flow/views/conditions/custom.vue';
import CustomToken from '@/views/reports/forms/flow/views/conditions/custom-token.vue';
import QueryHeader from '@/views/reports/forms/flow/views/conditions/query-header.vue';
import DayOfWeek from '@/views/reports/forms/flow/views/conditions/day-of-week.vue';
import DeviceType from '@/views/reports/forms/flow/views/conditions/device-type.vue';
import Ip from '@/views/reports/forms/flow/views/conditions/ip.vue';
import Referrer from '@/views/reports/forms/flow/views/conditions/referrer.vue';
import ReferrerDomain from '@/views/reports/forms/flow/views/conditions/referrer-domain.vue';
import UserAgent from '@/views/reports/forms/flow/views/conditions/user-agent.vue';
import TimeOfDay from '@/views/reports/forms/flow/views/conditions/time-of-day.vue';
import Timezone from '@/views/reports/forms/flow/views/conditions/timezone.vue';
import Uniqueness from '@/views/reports/forms/flow/views/conditions/uniqueness.vue';
import BotFilter from '@/views/reports/forms/flow/views/conditions/bot-filter.vue';
import Webview from '@/views/reports/forms/flow/views/conditions/webview.vue';
import Crawler from '@/views/reports/forms/flow/views/conditions/crawler.vue';
import Proxy from '@/views/reports/forms/flow/views/conditions/proxy.vue';
import VisitCap from '@/views/reports/forms/flow/views/conditions/visit-cap.vue';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';
import { mixins } from 'vue-class-component';
import IpBlacklisted from '@/views/reports/forms/flow/views/conditions/ip-blacklisted.vue';
import IpDataCenter from '@/views/reports/forms/flow/views/conditions/ip-data-center.vue';
import IpWithFrequentEvents from '@/views/reports/forms/flow/views/conditions/ip-with-frequent-events.vue';
import IpWithFrequentCampaignEvents from '@/views/reports/forms/flow/views/conditions/ip-with-frequent-campaign-events.vue';
import UniqOfferViewer from '@/views/reports/forms/flow/views/conditions/uniq-offer-viewer.vue';
import ExternalId from '@/views/reports/forms/flow/views/conditions/external-id.vue';

@Component({
  components: {
    ExternalId,
    UniqOfferViewer,
    BrandAndModel,
    BrowserAndVersion,
    OsAndVersion,
    Dictionary,
    ConnectionType,
    Custom,
    CustomToken,
    QueryHeader,
    DayOfWeek,
    DeviceType,
    Ip,
    Referrer,
    UserAgent,
    TimeOfDay,
    Uniqueness,
    BotFilter,
    Timezone,
    Webview,
    ReferrerDomain,
    Crawler,
    Proxy,
    VisitCap,
    IpBlacklisted,
    IpDataCenter,
    IpWithFrequentEvents,
    IpWithFrequentCampaignEvents,
  }
})
export default class RuleSettings extends mixins<PlanLimitsMixin>(PlanLimitsMixin) {
  @Prop() target: any;
  @Prop() rule: any;
  @Prop() active_name: any;
  @Prop() relation: string = 'and';

  @Watch('active_name')
  setActiveName(v: string){
    this.name = v;

    setTimeout(() => {
      this.$store.commit('loading', false);
    }, 1000);
  }

  name: string = '';

  get defaultConditions():Array<Rules.condition>{
    const result = [
      { name: this.t('Brand and Model'), condition: 'brand' },
      { name: this.t('Browser and Version'), condition: 'browser' },
      { name: this.t('Connection Type'), condition: 'connectType' },
      { name: this.t('Country'), condition: 'country' },
      { name: this.t('State / Region'), condition: 'state' },
      { name: this.t('City'), condition: 'city' },
      { name: this.t('Custom Token'), condition: 'customToken' },
      { name: this.t('Query Header'), condition: 'queryHeader' },
      { name: this.t('Custom 1'), condition: 'custom1' },
      { name: this.t('Custom 2'), condition: 'custom2' },
      { name: this.t('Custom 3'), condition: 'custom3' },
      { name: this.t('Custom 4'), condition: 'custom4' },
      { name: this.t('Custom 5'), condition: 'custom5' },
      { name: this.t('Custom 6'), condition: 'custom6' },
      { name: this.t('Custom 7'), condition: 'custom7' },
      { name: this.t('Custom 8'), condition: 'custom8' },
      { name: this.t('Custom 9'), condition: 'custom9' },
      { name: this.t('Custom 10'), condition: 'custom10' },
      { name: this.t('Day of Week'), condition: 'dayOfWeek' },
      { name: this.t('Device Type'), condition: 'deviceType' },
      { name: this.t('IP'), condition: 'ip' },
      { name: this.t('ISP'), condition: 'isp' },
      { name: this.t('Language'), condition: 'language' },
      { name: this.t('Mobile Carrier'), condition: 'mobileCarrier' },
      { name: this.t('OS and Version'), condition: 'os' },
      { name: this.t('Referrer'), condition: 'referrer' },
      { name: this.t('Referrer Domain'), condition: 'referrerDomain' },
      { name: this.t('Time of Day'), condition: 'timeOfDay' },
      { name: this.t('User Agent'), condition: 'userAgent' },
      { name: this.t('Uniqueness'), condition: 'uniqueness' },
      { name: this.t('Recurring Conversion'), condition: 'uniqOfferViewer' },
      { name: this.t('Bot Filter Marks'), condition: 'botMark' },
      { name: this.t('WebView'), condition: 'webViewMark' },
      { name: this.t('Crawler'), condition: 'crawler' },
      { name: this.t('Proxy'), condition: 'proxy' },
      { name: this.t('Visits Cap'), condition: 'visitCap' },
      { name: this.t('Suspicious Traffic (blacklisted IPs)'), condition: 'ipBlacklisted' },
      { name: this.t('Suspicious Traffic (data centres IPs)'), condition: 'ipDataCenter' },
      { name: this.t('Suspicious Traffic (Frequent Events)'), condition: 'ipWithFrequentEvents' },
      { name: this.t('Suspicious Traffic (Frequent Campaign Events)'), condition: 'ipWithFrequentCampaignEvents' },
      { name: this.t('External ID'), condition: 'externalId' },
    ]
    // if(this.$FF.visitsCapEnabled){
    //   result.push({ name: this.t('Visits Cap'), condition: 'visitCap' })
    // }
    return result
  }

  conditions: Array<Rules.condition> = [];
  created(){
    this.conditions = this.defaultConditions;
  }

  get menuList() {
    return this.conditions
      .filter((item) => !item.selected)
      .map<Bemob.ListItem>((item) => ({
        key: item.condition,
        title: item.name,
        planLimits: this.conditionPlanLimits(item.condition),
        click: () => this.add(item)
      }));
  }

  get isTimezoneAvailable() {
    return this.is_selected('timeOfDay') || this.is_selected('dayOfWeek');
  }

  get isClientHintsNoticeVisible() {
    return Object.keys(this.rule.conditions).some((item)=>[ 'os', 'browser', 'deviceType','brand' ].includes(item))
  }

  @Watch('rule.conditions')
  changeConditions(value: any) {
      if(!value) {
        return;
      }
      let rules = Object.keys(value);
      this.conditions.forEach((item, index) => {
        let hasRule = rules.indexOf(item.condition) !== -1;
        this.$set(this.conditions[index], `selected`, hasRule)
      });
  }

  @Watch('relation')
  onChangeRuleLogicalRelation(value: string) {
    this.$emit('update:relation', value);
  }

  add(item: any) {
    let index = this.conditions.indexOf(item);
    if (index !== -1) {
      this.conditions[index].selected = true;
      this.$set(this.conditions, index, this.conditions[index]);
    }
  }

  remove(name: any) {
    this.conditions = this.conditions.map(item => {
      if (item.selected && item.condition === name) {
        return {
          ...item,
          selected: false,
        }
      }
      return item
    })

    this.$delete(this.rule.conditions, name);

    if(!this.isTimezoneAvailable && this.rule.conditions.timezone) {
      this.$delete(this.rule.conditions, 'timezone');
    }
  }

  is_selected(type: any) {
    return this.selected.indexOf(type) !== -1;
  }

  get selected() {
    return this.conditions
      .filter((e: any) => e.selected)
      .map((e: any) => e.condition);
  }

  deselect_all() {
    this.conditions = this.conditions.map(item => ({
      ...item,
      selected: false,
    }))
    this.rule.conditions = {};
  }

  get rule_active() {
    return this.rule.status === 'active';
  }

  set rule_active(val: boolean) {
    if (val) this.rule.status = 'active';
    else this.rule.status = 'inactive';
  }
}
